<template>
  <div>
    <div class="container is-flex-direction-column" style="justify-content: center !important">
      <a href='https://www.freepik.com/vectors/abstract'>
        <img src="./../../assets/not-found.jpg" alt="NOT FOUND">
        <p>Abstract vector created by gstudioimagen - www.freepik.com</p>
      </a>

    </div>
  </div>
</template>

<script>
  export default {

  }
</script>

<style lang="scss" scoped>

</style>
